import axios from "axios";
import { useSnackbar } from "notistack";
import * as datadog from "src/util/datadog";

export const useError = () => {
  const { enqueueSnackbar } = useSnackbar();
  return {
    error: (e: unknown) => {
      datadog.error(e, {});
    },
    errorAlert: (message: string | undefined, error?: unknown) => {
      let finalMessage = message;
      if (!finalMessage && axios.isAxiosError(error)) {
        finalMessage =
          error.response?.data?.message || (error.response?.data as string);
      }
      enqueueSnackbar(finalMessage || "Something went wrong", {
        variant: "error",
      });
      datadog.error(error, { originalMessage: message });
    },
  };
};
